module.exports = __webpack_public_path__ + "img/blue_031.b59be1d0.png";